<script>
import { mapActions } from 'vuex';

export default {
	name: 'App',
	data() {
		return {
			userInfo: {},
			menuList: [],
			showType: false,
			schoolName: '',
			list: [],
			cb: null,
			str: '',
			searchProps: {
				showLoading: false,
				typeList: [],
			},
			cx_lx: '',
			isMounted: true,
			searchVal: '',
			defaultValue: '',
		};
	},
	watch: {
		async '$route.path'(path) {
			const blackRoute = ['login', 'NewWindowDetail', 'excelPrint', 'SsoStandard'];
			this.showType = !blackRoute.includes(path.split('/')[1]);
			this.showType ? await this.getList() : null;
			if (this.isMounted && this.showType) {
				this.getType();
				this.isMounted = false;
			}
			axf.history = this.$router;
		},
		'$store.state.global.schoolName'(val, oldVal) {
			this.schoolName = val;
		},
		menuList() {
			// 获取k12参数
			Promise.all([
				this.getDicAction({
					param_code: 'K12_ENABLE',
					type: 'isK12',
				}),
				this.getDicAction({
					param_code: 'CUS_YX_MC',
					type: 'yx',
				}),
				this.getDicAction({
					param_code: 'CUS_ZY_MC',
					type: 'zy',
				}),
				this.getDicAction({
					param_code: 'CUS_BJ_MC',
					type: 'bj',
				}),
				// 新增是否显示缴费年度
				this.getDicAction({
					param_code: 'SF_ZS_JFND',
					type: 'sfzsJfnd',
				}),
			]);
		},
	},
	async created() {
		a.title('E付通');
		const blackRoute = ['login', 'NewWindowDetail', 'excelPrint', 'SsoStandard'];
		// localStorage.setItem('openInNewPage', 1);
		// this.$store.commit('axfUI/setOpenInNewPage', 1);
		this.showType = !blackRoute.includes(location.href.split('/epay/')[1]);
		this.showType ? await this.getList(true) : null;
		axf.history = this.$router;
		if (this.isMounted && this.showType) {
			this.getType();
			this.isMounted = false;
		}
	},
	async mounted() {
		a.api('getConfigByKey').then((res) => {
			window.$fromServerConstant = {
				...(res.result || {}),
			};
			this.schoolName = localStorage.schoolName || '';
		});
		if (this.showType && this.isMounted) {
			await this.getUserInfo();
		}
	},
	methods: {
		...mapActions(['getDicAction']),
		async getList() {
			const menuList = await a.api('getList', {}).then(res => res.result);
			this.menuList = menuList;
		},
		getType() {
			axf.api('commonRequest', {
				url: '/upms-sys/sysdicitem/findListCon',
				dic_code: 'PERSON_CX_LX',
			}).then((res) => {
				const { searchInput } = this.$refs.headerTool.$refs.search.$refs;
				const headSearch = JSON.parse(localStorage.getItem('headSearch')) || {};
				const { user_no } = this.userInfo;
				const defaultValue = (user_no && headSearch[user_no])
					? headSearch[user_no] : res.result[0].item_code;
				this.defaultValue = defaultValue;
				this.cx_lx = res.result[0].item_code;
				this.searchProps.typeList = res.result.map(item => ({
					value: item.item_code,
					label: item.item_name,
				}));
			});
		},
		searchClick() {
			const { searchInput } = this.$refs.headerTool.$refs.search.$refs;
			const value = searchInput.$refs.input.value.trim();
			if (value) {
				this.searchVal = value;
				this.searchProps.showLoading = true;
				this.$nextTick(() => {
					axf.api('commonRequest', {
						url: '/axinsf/cusinfo/queryByCusStr',
						cus_str: value,
						cx_lx: this.cx_lx,
					}).then((res) => {
						searchInput.broadcast('ElAutocompleteSuggestions', 'visible', [!!res.result.length]);
						const data = res.result.map((one) => {
							const { sbh, xm, bj_mc, sbh_lx_mc, xh } = one;
							const label = this.searchProps.typeList.find(one => one.value ===
								this.cx_lx).label;
							const is_xm = this.cx_lx === 'XM';
							if (one.lx === '1') {
								one.value = this.cx_lx === 'XH' ?
									`学号：${xh}  姓名：${xm}  班级：${bj_mc}` :
									`${label}：${is_xm ? xm : sbh}  学号：${xh}  ${is_xm ? '' : `姓名：${xm}`}  班级：${bj_mc}`;
							} else {
								one.value = this.cx_lx === 'XM' ?
									`${sbh_lx_mc}：	${sbh}  姓名：${xm}` :
									`${label}：${sbh}`;
							}
							return one;
						});
						localStorage.setItem('headSearch', JSON.stringify({
							[this.userInfo.user_no]: this.cx_lx,
						}));
						if (!data.length) {
							this.$message.info('未搜索到数据');
						}
						if (data.length === 1) {
							this.onSelect(data[0]);
						} else { this.cb(data); }
						this.searchProps.showLoading = false;
					}).catch((e) => {
						this.searchProps.showLoading = false;
					});
				});
			}
		},
		doSearch(str, cb) {
			const { searchInput } = this.$refs.headerTool.$refs.search.$refs;
			searchInput.broadcast('ElAutocompleteSuggestions', 'visible', [false]);
			searchInput.loading = false;
			// this.str = str;
			this.cb = cb;
		},
		onSelect(data) {
			const { searchInput } = this.$refs.headerTool.$refs.search.$refs;
			searchInput.handleInput(this.searchVal);
			this.$store.commit('setStudentMessageObject', data);
			axf.goto('/SearchInformation');
		},
		async getUserInfo() {
			axf.api('commonRequest', {
				url: '/upms-sys/sysuser/getThis',
			}).then((res) => {
				this.userInfo = res.result;
			});
		},
	},
};
</script>

<template>
	<div id="app" :class="$route.name === 'SsoStandard' ? 'sso' : ''" class="epay">
		<div v-if="showType" id="main-view-body" class="epay-main flex">
			<axf-menu :nav-list="menuList" />
			<axf-body>
				<axf-header :title="schoolName">
					<axf-header-tools
						slot="tools"
						ref="headerTool"
						:search-props="searchProps"
						:default-value="defaultValue"
						logout-url="/logout"
						@doSearch="doSearch"
						@onSelect="onSelect"
						@searchClick="searchClick"
						@typeChange="val => {
							cx_lx = val;
							cb && cb([]);
						}"
					/>
				</axf-header>
				<!-- <axf-tabs /> -->
				<axf-container min-width="1020px">
					<router-view :key="$route.meta.type" />
				</axf-container>
			</axf-body>
		</div>
		<slot v-else>
			<router-view :key="$route.meta.type" />
		</slot>
		<form id="form" action="/epay/api?method=login" method="post">
			<input type="hidden" name="loginType" value="SSO">
			<input :value="$route.query.username" type="hidden" name="username">
			<input :value="'bsZOiJe4UG5jDQyjqyimw9JIgqFQp6dROT6DCQm0WPQYhzFHdQNw6J9yXGieBY/YtcWCRoMjBWCxaSkSlUjuIfbTe/8MxsMQxf97o6lEm6QsBjdR3nvxKazbTgoO4F5nsFn0wBI7ELalnqz7xROlgdS9ExK5W1fnU7W0lrfB6RmmRLKLUqWCU+/ji19XeEEQ6BztzoqughkVVcGFYDlRs3g4L5jQK2S+'" type="hidden" name="token">
		</form>
	</div>
</template>

<style lang='less'>
.sso {
	background-color: #eff0f1;
	display: flex;
	align-items: center;
	justify-content: center;
	.tips-info {
		text-align: center;
	}
}
	.epay {
		height: 100%;

		.epay-main {
			height: 100%;
		}
	}
	.axf-container::-webkit-scrollbar {
		display: none!important;
	}
	.b-tabs::-webkit-scrollbar {
		display: none!important;
	}
</style>
